// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R_FfPJGpW9llo1 {
  box-sizing: content-box;
  max-width: 300px;
  max-height: 300px;
  padding: var(--ds-space-100, 8px) var(--ds-space-150, 12px);
  border-radius: var(--ds-border-radius-100, 4px);
  background: var(--ds-surface-overlay, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
}
`, ""]);
// Exports
export var tooltipPrimitiveLight = `R_FfPJGpW9llo1`;
export default ___CSS_LOADER_EXPORT___;
